import { render, staticRenderFns } from "./NewMember.vue?vue&type=template&id=ef8909d8&scoped=true&"
import script from "./NewMember.vue?vue&type=script&lang=ts&"
export * from "./NewMember.vue?vue&type=script&lang=ts&"
import style0 from "./NewMember.vue?vue&type=style&index=0&id=ef8909d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8909d8",
  null
  
)

export default component.exports